import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function LIRA2030() {
  return (
    <div className="art-page">
      <SEO
        title="LIRA 2030 — Indoor Air Quality Study, Kampala & Mwanza"
        description="CIRCODU participated in the LIRA 2030 programme to improve indoor air quality in selected urban communities in Kampala and Mwanza."
        keywords="LIRA 2030, indoor air quality, Kampala, Mwanza, clean cooking, sustainable development, CIRCODU, ICSU, NASAC, SDG 11, sustainable cities, urban sustainability, transdisciplinary research, energy transitions, air pollution reduction, improved cooking technologies, urban communities Uganda, urban communities Tanzania"
        url="/Leading-Integrated-Research-for-Agenda-2030-in-Africa-LIRA-2030-Indoor-Air-Quality-Study"
        datePublished="2019-03-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              LIRA 2030 — Indoor Air Quality Study, Kampala &amp; Mwanza
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              March 01, 2019
            </div>
            <h1 className="art-title">
              Leading Integrated Research for Agenda 2030 in Africa (LIRA 2030)
              — Indoor Air Quality Study
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Between 2017 and 2019, CIRCODU participated in the{" "}
                <strong>
                  Leading Integrated Research for Agenda 2030 in Africa (LIRA
                  2030)
                </strong>{" "}
                programme — a five-year initiative of the{" "}
                <strong>International Council for Science (ICSU)</strong> and
                the{" "}
                <strong>Network of African Science Academies (NASAC)</strong>{" "}
                designed to generate solutions-oriented, transdisciplinary
                research to address urban sustainability challenges across the
                continent.
              </p>
              <p>
                CIRCODU's assignment, conducted in partnership with{" "}
                <strong>Makerere University</strong> and the{" "}
                <strong>University of Dar es Salaam</strong>, focused on
                improving indoor air quality in selected urban communities in{" "}
                <strong>Kampala, Uganda</strong> and{" "}
                <strong>Mwanza, Tanzania</strong> through the adoption of better
                energy technologies. The project was funded through LIRA 2030's
                call on advancing the implementation of{" "}
                <strong>SDG 11 — Sustainable Cities and Communities</strong>.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                The project combined research with community engagement to test
                the effectiveness of transdisciplinary approaches in translating
                scientific knowledge into practical energy transitions. In
                Kampala, CIRCODU contributed its expertise in cookstove testing,
                air quality monitoring, and household energy assessment to the
                research design and field implementation — working alongside
                academic partners to measure baseline indoor air pollution
                levels and track reductions following the introduction of
                improved cooking and lighting technologies.
              </p>
              <p>
                The transdisciplinary dimension of the project — bringing
                together scientists, local authorities, communities, and
                industry — aligned with CIRCODU's established approach of
                embedding field research within genuine community partnerships
                rather than imposing externally designed solutions.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                LIRA 2030 represented CIRCODU's engagement with a sophisticated
                international research framework explicitly linked to the 2030
                Sustainable Development Goals. The project extended CIRCODU's
                impact measurement work into the urban air quality domain and
                strengthened its academic and research partnerships at both
                national and continental levels.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's research and academic
                partnerships, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
